import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';

import s from 'components/bolt/burgerMenu/burgerMenu.sss';

export default class BurgerMenu extends Component {

	render(props) {
		const {
			type,
			style,
			lineStyle,
			dark,
			showtimesOverlayOpen,
			homeEntOverlayOpen,
			widgetFullyExpanded,
			navOpen,
			homeScrolled,
			isSinglePageIframed,
			showtimesSearchOverlay,
			videoOverlayOpen,
			oneSheetOverlay,
			oneSheetOverlayOpen,
			trailerOverlayOpen,
			trailerOverlay,
			calendarRemind,
			calendarRemindOpen,
			extraClass
		} = props;

		return (
			<div
				class={joinClasses(
					s.container,
					s[type],
					dark && s.dark,
					(showtimesOverlayOpen || widgetFullyExpanded) && s.showtimes,
					homeEntOverlayOpen && s.homeEnt,
					navOpen && s.navOpen,
					homeScrolled && s.homeScrolled,
					isSinglePageIframed && s.hidden,
					showtimesSearchOverlay && s.searching,
					videoOverlayOpen && s.video,
					oneSheetOverlay && s.oneSheetOverlay,
					oneSheetOverlayOpen && s.oneSheetOverlayOpen,
					trailerOverlayOpen && s.trailerOverlayOpen,
					trailerOverlay && s.trailerOverlay,
					calendarRemindOpen && s.calendarRemindOpen,
					calendarRemind && s.calendarRemind,
					extraClass
				)}
				style={style}
			>
				<div style={lineStyle} class={s.line} />
				<div style={lineStyle} class={s.line} />
				<div style={lineStyle} class={s.line} />
			</div>
		);
	}
}
